<script lang="ts">
	import { getContextErrors } from '../errors'
	import { _ } from '@repo/i18n'
	import { slide } from 'svelte/transition'

	interface Props {
		name: string
	}

	let { name }: Props = $props()

	const errors = getContextErrors()
</script>

{#if errors && $errors?.[name]}
	<label class="block pt-1 pb-3 text-sm text-red-500" for={name} transition:slide|local>
		{$_($errors?.[name] && $errors?.[name].text)}
	</label>
{:else}
	<div class="mt-5" transition:slide|local></div>
{/if}
